<template>
  <layout>
    <page-header :header="$t('general.dashboard')" />
    <div
      v-if="currentDivision && $allows('administer')"
      class="content dashboard"
    >
      <filters @change="filterChanged" />
      <b-card :key="currentDivision.id">
        <companies-graph :period="period"></companies-graph>
        <car-class :period="period"></car-class>
        <payment-graph :period="period"></payment-graph>
        <partners-graph :period="period"></partners-graph>
        <general-graph :period="period"></general-graph>
        <tracking-graph :period="period"></tracking-graph>
      </b-card>
    </div>
  </layout>
</template>

<script>
import PaymentGraph from './graphs/PaymentGraph.vue'
import CarClass from './graphs/CarClass.vue'
import CompaniesGraph from './graphs/CompaniesGraph.vue'
import GeneralGraph from './graphs/GeneralGraph.vue'
import PartnersGraph from './graphs/PartnersGraph.vue'
import Filters from './Filters'
import moment from 'moment'
import TrackingGraph from './graphs/TrackingGraph'

export default {
  name: 'Dashboard',

  components: {
    Filters,
    PaymentGraph,
    CarClass,
    CompaniesGraph,
    GeneralGraph,
    PartnersGraph,
    TrackingGraph,
  },
  data() {
    return {
      period: {
        gte: moment()
          .subtract(7, 'd')
          .format('YYYY-MM-DD'),
        lte: moment().format('YYYY-MM-DD'),
      },
    }
  },
  methods: {
    filterChanged(params) {
      this.period = params.period
    },
  },
}
</script>

<style lang="scss">
.dashboard {
  h4 {
    text-align: center;
    margin-bottom: 20px;
    width: 100%;
  }
  .wrapper-payment,
  .wrapper-partners {
    margin-top: 40px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    canvas {
      max-height: 350px;
    }
    div.payments,
    .single-partner {
      //float: left;
      display: flex;
      justify-content: center;
      width: 50% !important;
      min-height: 300px;
    }
  }

  .companies .item-graph,
  .companies canvas {
    max-height: 350px;
  }

  .item-graph {
    min-height: 300px;
  }

  .nav.nav-tabs {
    text-align: center;
    display: flex;
    justify-content: center;
  }

  .nav.nav-tabs li {
    min-width: 190px;
  }

  @media (max-width: 992px) {
    canvas {
      margin: 20px 0;
    }
    h4 {
      font-size: 18px;
      text-align: center;
    }
    .wrapper-payment {
      div.payments {
        width: 100% !important;
      }
    }
  }
}
</style>
